import { $api } from '@service/RequestService';
import { timeStampToDate } from '@utils/index';
import { useQuery } from 'react-query';
import { ArrayParam, NumberParam, StringParam, useQueryParams } from 'use-query-params';

import { endPoints } from '../utils/constants/endPoint';
import { queryKeys } from '../utils/constants/queryKeys';
import { FacebookPagesType } from '../utils/models/FacebookPagesType';
import { FormLeadType } from '../utils/models/FormLeadType';

export function useGetFormLeadUsers() {
  const [query] = useQueryParams({
    search: StringParam,
    page: NumberParam,
    status: StringParam,
    forms: ArrayParam,
    startDate: StringParam,
    finishDate: StringParam,
    startDateFacebook: StringParam,
    finishDateFacebook: StringParam
  });

  const initial: {
    totalPages: number;
    currentPage: number;
    totalElements: number;
    users: FormLeadType[];
  } = {
    totalPages: 1,
    currentPage: 1,
    totalElements: 0,
    users: []
  };

  const { data = initial, ...arg } = useQuery<{
    totalPages: number;
    currentPage: number;
    totalElements: number;
    users: FormLeadType[];
  }>({
    queryKey: ['form-report-users-filter', query],
    queryFn: async () => {
      const { data } = await $api.post('/v1/form-report/filter', {
        ...query,
        size: 10,
        page: query?.page || 1
      });

      const users: FormLeadType[] = data?.data?.data;

      return {
        users: users
          ? users?.map(item => ({
              ...item,
              createdDate: timeStampToDate({ date: item?.createdDate, timeStamp: item?.createdTimestamp }),
              createdDateForm: timeStampToDate({ date: item?.createdDateForm, timeStamp: item?.createdTimestampForm })
            }))
          : users,
        totalPages: data?.data?.totalPages,
        currentPage: data?.data?.currentPage,
        totalElements: data?.data?.totalElements
      };
    },
    retry: false,
    refetchOnWindowFocus: false
  });

  return { ...data, ...arg };
}

export function useGetFormReport() {
  return useQuery<FacebookPagesType[]>({
    queryKey: [queryKeys.GET_FORM_REPORT],
    queryFn: async () => {
      const res = await $api.get(endPoints.GET_FORM_REPORT);

      return res?.data?.data;
    }
  });
}
